var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.61813 2.78839L2.43892 1.61011C0.887854 3.1624 0 5.26272 0 7.5015C0 12.1048 3.73171 15.8365 8.335 15.8365C12.9383 15.8365 16.67 12.1048 16.67 7.5015C16.67 5.26211 15.7817 3.16128 14.2299 1.60888L13.0509 2.78741C14.2933 4.0303 15.003 5.70866 15.003 7.5015C15.003 11.1841 12.0176 14.1695 8.335 14.1695C4.65237 14.1695 1.667 11.1841 1.667 7.5015C1.667 5.70915 2.37631 4.0312 3.61813 2.78839Z",
  fill: "#A4A4A4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0796 6.91213L12.2584 8.09087L8.92437 11.4249C8.59887 11.7504 8.07113 11.7504 7.74563 11.4249L4.41163 8.09087L5.59037 6.91213L7.5015 8.82325V0H9.1685V8.82325L11.0796 6.91213Z",
  fill: "#A4A4A4"
})));
export { SvgLogOut as ReactComponent };
export default __webpack_public_path__ + "assets/72817bba.svg";